module.exports = __webpack_public_path__ + "img/computer.66f36cbc.png";